// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import LaptopOutlinedSvg from "@ant-design/icons-svg/es/asn/LaptopOutlined";
import AntdIcon from '../components/AntdIcon';

var LaptopOutlined = function LaptopOutlined(props, ref) {
  return React.createElement(AntdIcon, Object.assign({}, props, {
    ref: ref,
    icon: LaptopOutlinedSvg
  }));
};

LaptopOutlined.displayName = 'LaptopOutlined';
export default React.forwardRef(LaptopOutlined);